<template>
  <div class="all-view column-view padding-15 scroll-y">

    <el-form label-width="100px" label-position="right"
             class="white-block-view-5px padding-15 padding-bottom-0 row-view">
      <el-form-item class="row-item" label="选择年份">
        <el-date-picker
          :clearable="false"
          style="width: 100%"
          v-model="time"
          type="year"
          format="yyyy"
          value-format="yyyy"
          :picker-options="pickerOptions"
          placeholder="选择年份">
        </el-date-picker>
      </el-form-item>

      <el-form-item class="row-item" label="">
        <el-button type="primary" icon="el-icon-search" @click="onSearchClick">查询会议</el-button>
      </el-form-item>
      <div class="row-item"></div>
    </el-form>


    <div class="white-block-view-5px padding-15 margin-top-15">
      <el-tabs type="border-card" v-model="currentTab" @tab-click="onSearchClick">
        <el-tab-pane v-for="item in tabs" :label="item.label" :key="item.id" :name="item.id"/>

        <vote-table v-show="currentTab==='1'" ref="voteTable" @onCreateVote="onCreateVote"
                    @refreshData="onSearchClick" ></vote-table>

        <div v-show="currentTab==='2'" style="overflow-x: scroll;overflow-y: scroll" class="padding-10">
          <first-table  ref="firstTable"></first-table>
        </div>
        <div v-show="currentTab==='3'" style="overflow-x: scroll;overflow-y: scroll" class="padding-10">
          <second-table  ref="secondTable"></second-table>
        </div>
        <div v-show="currentTab==='4'" style="overflow-x: scroll;overflow-y: scroll" class="padding-10">
          <third-table  ref="thirdTable"></third-table>
        </div>

        <div v-show="currentTab==='5'" style="overflow-x: scroll;overflow-y: scroll" class="padding-10">
          <fourth-table  ref="fourthTable"></fourth-table>
        </div>
      </el-tabs>


    </div>

  </div>

</template>

<script>
import voteTable from "@/views/setting/voteManagement/components/voteTable";
import firstTable from "@/views/setting/voteManagement/components/firstTable";
import secondTable from "@/views/setting/voteManagement/components/secondTable";
import thirdTable from "@/views/setting/voteManagement/components/thirdTable";
import fourthTable from "@/views/setting/voteManagement/components/fourthTable";
export default {
  //投片管理
  name: "VoteManagement",
  components: {voteTable,firstTable,secondTable,thirdTable,fourthTable},
  data() {
    return {
      time: '',
      pickerOptions: {
        disabledDate(time) {
          const currentYear = new Date().getFullYear();
          return time.getFullYear() < 2025 || time.getFullYear() > currentYear;
          // return time.getFullYear() < 2025 || time.getFullYear() > 2026;
        }
      },
      currentTab: '1',
      tabs: [
        {
          id: '1',
          label: '会议信息'
        },
        {
          id: '2',
          label: '局管领导干部年度考核测评结果汇总'
        },
        {
          id: '3',
          label: '领导班子年度考核测评结果汇总'
        },
        {
          id: '4',
          label: '局管领导干部政治素质测评结果汇总'
        },
        {
          id: '5',
          label: '新提拔干部民主评议表'
        },
      ],


    }
  },
  methods: {
    onSearchClick() {
      this.$nextTick(()=>{
        switch (this.currentTab) {
          case '1':
            this.getVotes();
            break;
          case '2':
            this.getLeaderSummary();
            break;
          case '3':
            this.getDeptSummary();
            break;
          case '4':
            this.getLeaderVoted();
            break;
          case '5':
            this.getPromotedDetail();
            break;
        }
      })
    },

    //局领导干部评分
    getLeaderSummary(){
      this.$refs.firstTable.showLoading();
      this.http.api('getLeaderSummary',{'year':this.time})
        .then(res=>{
          if(res.status){
            this.$refs.firstTable.setData(res.data)
          }else{
            this.$refs.firstTable.setData([])
            this.$commonUtils.showMessage(res.message,'error')
          }
        })
        .catch(error=>{
          this.$commonUtils.showMessage('请求失败','error')
          this.$refs.firstTable.setData([])
        })
    },

    //局领导干部评分
    getDeptSummary(){
      this.$refs.secondTable.showLoading();
      this.http.api('getDeptSummary',{'year':this.time})
        .then(res=>{
          if(res.status){
            this.$refs.secondTable.setData(res.data)
          }else{
            this.$refs.secondTable.setData([])
            this.$commonUtils.showMessage(res.message,'error')
          }
        })
        .catch(error=>{
          this.$commonUtils.showMessage('请求失败','error')
          this.$refs.secondTable.setData([])
        })
    },
    getLeaderVoted(){
      this.$refs.thirdTable.showLoading();
      this.http.api('getLeaderVoted',{'year':this.time})
        .then(res=>{
          if(res.status){
            this.$refs.thirdTable.setData(res.data)
          }else{
            this.$refs.thirdTable.setData([])
            this.$commonUtils.showMessage(res.message,'error')
          }
        })
        .catch(error=>{
          this.$commonUtils.showMessage('请求失败','error')
          this.$refs.thirdTable.setData([])
        })
    },


    getPromotedDetail(){
      this.$refs.fourthTable.showLoading();
      this.http.api('getPromotedData',{'year':this.time})
        .then(res=>{
          if(res.status){
            this.$refs.fourthTable.setData(res.data)
          }else{
            this.$refs.fourthTable.setData([])
            this.$commonUtils.showMessage(res.message,'error')
          }
        })
        .catch(error=>{
          this.$commonUtils.showMessage('请求失败','error')
          this.$refs.fourthTable.setData([])
        })
    },


    onCreateVote() {
      this.$prompt('确认生成【'+this.time+'】年度会议？该操作不可撤销', '一键生成年度会议', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '生成中...'
            this.http.api('createMeetingFast', {year:this.time}).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '确认'
                done()
                this.$commonUtils.showMessage('操作成功','success')
                this.getVotes();
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '确认'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确认'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })
    },

    //获取年度会议
    getVotes(){
      this.$refs.voteTable.showLoading();
      this.http.api('meetingList',{'year':this.time})
          .then(res=>{
            if(res.status){
              this.$refs.voteTable.setData(res.data)
            }else{
              this.$commonUtils.showMessage(res.message,'error')
              this.$refs.voteTable.setData([])
            }
          })
          .catch(error=>{
            this.$commonUtils.showMessage('请求失败','error')
            this.$refs.voteTable.setData([])
          })
    },

  },


  created() {
    const currentYear = new Date().getFullYear();
    this.time = String(currentYear);
    //请求当年的会议


    this.onSearchClick();

  },

}
</script>

<style scoped>

</style>
